/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type LastTripsByCustomerIdQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input']
  limit: Types.Scalars['Int']['input']
}>

export type LastTripsByCustomerIdQuery = {
  __typename?: 'Query'
  lastTripsByCustomerId: Array<{ __typename?: 'Trip'; active: boolean }> | null
}

export const LastTripsByCustomerIdDocument = gql`
    query LastTripsByCustomerId($id: ID!, $limit: Int!) {
  lastTripsByCustomerId(id: $id, limit: $limit) {
    active
  }
}
    `

/**
 * __useLastTripsByCustomerIdQuery__
 *
 * To run a query within a React component, call `useLastTripsByCustomerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastTripsByCustomerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastTripsByCustomerIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useLastTripsByCustomerIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    LastTripsByCustomerIdQuery,
    LastTripsByCustomerIdQueryVariables
  > &
    (
      | { variables: LastTripsByCustomerIdQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    LastTripsByCustomerIdQuery,
    LastTripsByCustomerIdQueryVariables
  >(LastTripsByCustomerIdDocument, options)
}
export function useLastTripsByCustomerIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LastTripsByCustomerIdQuery,
    LastTripsByCustomerIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    LastTripsByCustomerIdQuery,
    LastTripsByCustomerIdQueryVariables
  >(LastTripsByCustomerIdDocument, options)
}
// @ts-ignore
export function useLastTripsByCustomerIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LastTripsByCustomerIdQuery,
    LastTripsByCustomerIdQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  LastTripsByCustomerIdQuery,
  LastTripsByCustomerIdQueryVariables
>
export function useLastTripsByCustomerIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LastTripsByCustomerIdQuery,
        LastTripsByCustomerIdQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LastTripsByCustomerIdQuery | undefined,
  LastTripsByCustomerIdQueryVariables
>
export function useLastTripsByCustomerIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LastTripsByCustomerIdQuery,
        LastTripsByCustomerIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    LastTripsByCustomerIdQuery,
    LastTripsByCustomerIdQueryVariables
  >(LastTripsByCustomerIdDocument, options)
}
export type LastTripsByCustomerIdQueryHookResult = ReturnType<
  typeof useLastTripsByCustomerIdQuery
>
export type LastTripsByCustomerIdLazyQueryHookResult = ReturnType<
  typeof useLastTripsByCustomerIdLazyQuery
>
export type LastTripsByCustomerIdSuspenseQueryHookResult = ReturnType<
  typeof useLastTripsByCustomerIdSuspenseQuery
>
export type LastTripsByCustomerIdQueryResult = Apollo.QueryResult<
  LastTripsByCustomerIdQuery,
  LastTripsByCustomerIdQueryVariables
>
